// Wishlist functionality
class Wishlist {
  constructor() {
    this.storageKey = 'shopify_wishlist';
    this.init();
  }

  init() {
    this.updateHeaderCount();
    this.bindEvents();

    if (window.location.pathname.includes('/pages/wishlist')) {
      this.loadWishlistPage();
    }
  }

  // ─── Storage ────────────────────────────────────────────────────────────────

  getWishlist() {
    try {
      return JSON.parse(localStorage.getItem(this.storageKey) || '[]');
    } catch (e) {
      return [];
    }
  }

  saveWishlist(wishlist) {
    localStorage.setItem(this.storageKey, JSON.stringify(wishlist));
    this.updateHeaderCount();
  }

  addToWishlist(productData) {
    const wishlist = this.getWishlist();
    const exists = wishlist.find(item => item.handle === productData.handle);
    if (!exists) {
      wishlist.push(productData);
      this.saveWishlist(wishlist);
      return true;
    }
    return false;
  }

  removeFromWishlist(handle) {
    const wishlist = this.getWishlist().filter(item => item.handle !== handle);
    this.saveWishlist(wishlist);
  }

  isInWishlist(handle) {
    return this.getWishlist().some(item => item.handle === handle);
  }

  // ─── Header count ───────────────────────────────────────────────────────────

  updateHeaderCount() {
    const count = this.getWishlist().length;
    document.querySelectorAll('[data-wishlist-count]').forEach(el => {
      el.textContent = count;
      el.style.display = count === 0 ? 'none' : 'flex';
    });
  }

  // ─── Events ─────────────────────────────────────────────────────────────────

  bindEvents() {
    document.addEventListener('click', (e) => {

      // Wishlist toggle button (product cards / PDP)
      const wishlistBtn = e.target.closest('.wishlist-btn');
      if (wishlistBtn) {
        e.preventDefault();
        e.stopPropagation();
        this.toggleWishlist(wishlistBtn);
        return;
      }

      // Remove single item on wishlist page
      const removeBtn = e.target.closest('.wishlist-remove-btn');
      if (removeBtn) {
        this.removeFromWishlist(removeBtn.dataset.handle);
        this.loadWishlistPage();
        return;
      }

      // Clear all
      const clearBtn = e.target.closest('#clear-wishlist');
      if (clearBtn) {
        if (confirm('Are you sure you want to clear your wishlist?')) {
          localStorage.removeItem(this.storageKey);
          this.updateHeaderCount();
          this.loadWishlistPage();
        }
        return;
      }


    });


    this.updateWishlistButtons();
  }

  // ─── Toggle (product cards / PDP) ──────────────────────────────────────────

  toggleWishlist(btn) {
    const handle = btn.dataset.productHandle;

    if (this.isInWishlist(handle)) {
      this.removeFromWishlist(handle);
      btn.classList.remove('active');
    } else {
      fetch(`/products/${handle}.js`)
        .then(r => r.json())
        .then(product => {
          const productData = {
            id: product.id,
            handle: product.handle,
            title: product.title,
            price: product.price_min !== undefined ? product.price_min : product.price,
            compare_at_price: product.compare_at_price_min || null,
            image: product.featured_image,
            url: `/products/${product.handle}`
          };
          this.addToWishlist(productData);
          btn.classList.add('active');
        })
        .catch(err => console.error('Wishlist fetch error:', err));
    }
  }

  // ─── Sync button states across the page ────────────────────────────────────

  updateWishlistButtons() {
    document.querySelectorAll('.wishlist-btn').forEach(btn => {
      const handle = btn.dataset.productHandle;
      btn.classList.toggle('active', this.isInWishlist(handle));
    });
  }

  // ─── Render wishlist page ───────────────────────────────────────────────────

  loadWishlistPage() {
    const wishlist = this.getWishlist();
    const emptyDiv = document.getElementById('wishlist-empty');
    const gridDiv  = document.getElementById('wishlist-grid');
    const clearBtn = document.getElementById('clear-wishlist');

    if (!gridDiv) return;

    if (wishlist.length === 0) {
      emptyDiv.style.display = 'block';
      gridDiv.style.display  = 'none';
      if (clearBtn) clearBtn.style.display = 'none';
    } else {
      emptyDiv.style.display = 'none';
      gridDiv.style.display  = 'grid';
      if (clearBtn) clearBtn.style.display = 'block';

      gridDiv.innerHTML = wishlist.map(item => {
        const itemUrl = item.url || `/products/${item.handle}`;
        const compareHTML = item.compare_at_price && item.compare_at_price > item.price
          ? `<s class="wishlist-item-compare-price">${this.formatMoney(item.compare_at_price)}</s>`
          : '';

        return `
          <div class="wishlist-item">

            <!-- Hover overlay (tint) -->
            <div class="wishlist-item-overlay" aria-hidden="true"></div>

            <!-- Remove button — visible on hover via CSS -->
            <button class="wishlist-remove-btn" data-handle="${item.handle}" aria-label="Remove ${item.title} from wishlist">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
                <line x1="18" y1="6" x2="6" y2="18"/>
                <line x1="6" y1="6" x2="18" y2="18"/>
              </svg>
            </button>

            <!-- Image — contain so nothing is cropped -->
            <a href="${itemUrl}" class="wishlist-item-image-link">
              <div class="wishlist-item-image-wrap">
                <img
                  src="${item.image}"
                  alt="${item.title}"
                  class="wishlist-item-image"
                  loading="lazy"
                >
              </div>
            </a>

            <!-- Info -->
            <div class="wishlist-item-info">
              <a href="${itemUrl}" class="wishlist-item-title">${item.title}</a>

              <div class="wishlist-item-prices">
                <span class="wishlist-item-price">${this.formatMoney(item.price)}</span>
                ${compareHTML}
              </div>

              <!-- Quick View — goes directly to PDP -->
              <a href="${itemUrl}" class="wishlist-quick-view-btn">Quick View</a>
            </div>

          </div>
        `;
      }).join('');
    }
  }


  // ─── Helpers ────────────────────────────────────────────────────────────────

  formatMoney(cents) {
    if (!cents && cents !== 0) return '';
    return 'Rs\u00a0' + (cents / 100).toFixed(2);
  }
}

// Initialise on DOM ready
document.addEventListener('DOMContentLoaded', () => {
  window.wishlistApp = new Wishlist();
});